<div class="card card-p2p-fundraiser-detail mb-3 mt-4">
    <div class="card-body card-body--p2p">
        <div class="d-flex">
            <div class="d-block">
                <div class="position-relative mb-4">
                    <img [src]="image" style="border-radius: 5px" alt="P2P User Image" class="img-fluid rounded-start" style="width: 88px; min-height: 80px; border-radius: 4px;">
                </div>
            </div>
            <div class="d-flex flex-column w-100 ml-4 mr-3">
                <div class="d-flex align-items-center justify-content-between">
                    <h5 (click)="fundraiserSelected()" class="fundraiser-name subtitle-1--weight-regular cursor--pointer mb-0 pb-1">{{fundraiser.displayName}}</h5>
                    <span class="body-2">{{fundraiser.createdByName || fundraiser.userInfo.name}}</span>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                    <span class="body-2" style="color: #676767;">{{optionName}}</span>
                    <span class="body-3" style="color: #676767;">{{updated | activityTimer:index}}</span>
                </div>
                <div class="row mt-3">
                    <div class="col-8">
                        <div class="d-block">
                            <div class="d-block progress md-progress p2p-detail-progress">        
                                <div 
                                    role="progressbar" [attr.aria-valuenow]="progressValue" aria-valuemin="0" aria-valuemax="100"
                                    class="progress-bar active" 
                                    [style]="progressNgStyle">
                                </div>                                
                                <div class="progress-value text-center p2p-detail-progress--text">{{fundraiser.raised | currency:'USD':'symbol-narrow':'1.0-0'}} of {{fundraiser.goal | currency:'USD':'symbol-narrow':'1.0-0'}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="divider"></div>
        @if(fundraiserDonations.length > 0) {
            <div class="row body-2 grey-text my-2">
                <div class="col-3 text-center">
                    Amount
                </div>
                <div class="col-3 text-center">
                    Date
                </div>
            </div>
            @for(donation of fundraiserDonations; track donation.id; let index = $index) {
                <app-fundraiser-donation [donation]="donation" [index]="index"></app-fundraiser-donation>
            }
        }
        @else {
            <div class="d-flex w-100 justify-content-center align-items-center mt-4">
                No Donations Made
            </div>
        }
    </div>
</div>